<div class="job-summary"
     (scroll)="onContentScroll($event)"
     data-testid="cm-container-lot-summary">
  <div class="sticky-layer sticky-layer--lot"
       #lotHeaderLayer>
    <schedule-detail-header [title]="''"
                            [backCallback]="goBack"
                            [backLabel]="getBackLabel()"
                            [showCloud]="true"
                            [showBackgroundRefreshBar]="false">
      <ng-container header-right>
        <button type="button"
                class="lot-kebab-btn"
                aria-label="Lot options"
                data-testid="cm-btn-lot-kebab"
                (click)="openLotMenu()">
          <i class="pi pi-ellipsis-v"></i>
        </button>
      </ng-container>
    </schedule-detail-header>

    <div class="lot-headline"
         data-testid="cm-container-lot-headline">
      <div class="lot-photo-wrapper">
        <button type="button"
                class="lot-photo-placeholder"
                [class.lot-photo-placeholder--has-photo]="!!currentLotPhoto()"
                aria-label="Lot photo options"
                data-testid="cm-btn-lot-photo"
                (click)="openLotPhotoMenu()">
          @if (currentLotPhoto()) {
            <img [src]="lotPhotoUrl()"
                 alt=""
                 class="lot-photo-image" />
          } @else {
            <i class="pi pi-camera"></i>
          }
        </button>
        @if (!currentLotPhoto()) {
          <span class="lot-photo-edit-badge">
            <i class="pi pi-pen-to-square"></i>
          </span>
        }
      </div>
      <div class="lot-headline-text">
        @if (dataLoaded) {
          <div class="lot-title"
               data-testid="cm-text-lot-title">Lot {{ lot?.lotBlock }}</div>
          <div class="lot-subtitle"
               data-testid="cm-text-lot-address">{{ lot?.streetAddress }}</div>
          <div class="lot-subtitle lot-subtitle--muted"
               data-testid="cm-text-sales-community">
            {{ lot?.salesCommunityName }}
            @if (getClosingDate()) {
              <span data-testid="cm-text-closing-date">&nbsp;&middot; Closes {{ getClosingDate() | date:'MMM d, y' }}</span>
            }
          </div>
        } @else {
          <p-skeleton height="1.25rem"
                      width="8rem"></p-skeleton>
          <p-skeleton height="1rem"
                      width="12rem"></p-skeleton>
          <p-skeleton height="1rem"
                      width="9rem"></p-skeleton>
        }
      </div>
    </div>
    <div class="app-background-refresh-indicator-wrapper">
      <app-background-refresh-indicator [active]="isRefreshingInBackground()" />
    </div>
  </div>

  @if (dataLoaded) {
    <div class="job-summary-content job-summary-fade"
         [appDataUpdatedFade]="dataUpdatedPulse()"
         data-testid="cm-container-summary-content">
      <h2 class="section-title"
          data-testid="cm-label-action-required">Action Required</h2>

      @if (actionSummary.overdueItemsCount > 0) {
        <button type="button"
                class="action-card action-card--overdue"
                (click)="viewOverdueItems()"
                data-testid="cm-btn-overdue-items">
          <span class="action-card-icon"
                aria-hidden="true">
            <i class="pi pi-clock"></i>
          </span>
          <span class="action-card-body">
            <span class="action-card-title"
                  data-testid="cm-text-overdue-count">{{ actionSummary.overdueItemsCount }} Overdue {{ actionSummary.overdueItemsCount === 1 ? 'Item' : 'Items' }}</span>
            <span class="action-card-subtext"
                  data-testid="cm-text-overdue-subtext">{{ getOverdueSubtext() }}</span>
          </span>
          <i class="pi pi-chevron-right action-card-chevron"
             aria-hidden="true"></i>
        </button>
      }

      <button type="button"
              class="action-card"
              (click)="viewOpenItems()"
              data-testid="btn-open-items">
        <span class="action-card-icon"
              aria-hidden="true">
          <i class="pi pi-clipboard"></i>
        </span>
        <span class="action-card-body">
          <span class="action-card-title"
                data-testid="cm-text-open-items-count">{{ actionSummary.openItemsCount }} Open {{ actionSummary.openItemsCount === 1 ? 'Item' : 'Items' }}</span>
          <span class="action-card-subtext"
                data-testid="cm-text-open-items-subtext">{{ getNextDueSubtext() }}</span>
        </span>
        <i class="pi pi-chevron-right action-card-chevron"
           aria-hidden="true"></i>
      </button>
    </div>

    <div class="sticky-layer sticky-layer--steps"
         [class.is-scrolled]="isScrolled"
         [style.top.px]="lotHeaderHeight"
         data-testid="cm-container-steps-header">
      <h2 class="section-title">Build Quality Steps</h2>
      <button type="button"
              class="steps-toggle"
              (click)="toggleShowAllSteps()"
              [attr.aria-expanded]="showAllSteps"
              data-testid="cm-btn-toggle-steps">
        {{ showAllSteps ? 'Show Less' : 'View All Steps' }}
        <i class="pi"
           [class.pi-chevron-down]="!showAllSteps"
           [class.pi-chevron-up]="showAllSteps"
           aria-hidden="true"></i>
      </button>
    </div>

    <div class="job-summary-content job-summary-content--steps">
      <app-score-card-list [jobs]="jobs"
                           [lot]="lot"
                           [showAllSteps]="showAllSteps"></app-score-card-list>
    </div>
  } @else {
    <div class="job-summary-content"
         data-testid="cm-container-summary-skeleton">
      <p-skeleton height="4.5rem"></p-skeleton>
      <p-skeleton height="4.5rem"></p-skeleton>
      <p-skeleton height="1.5rem"
                  width="12rem"></p-skeleton>
      <p-skeleton height="4.5rem"></p-skeleton>
    </div>
  }
</div>

<app-bottom-sheet [(isOpen)]="isLotMenuOpen"
                  [contentTemplate]="lotMenuTemplate"
                  [hasFooter]="false"
                  [isFullScreen]="false"
                  [preventOverlayClose]="false"
                  data-testid="cm-sheet-lot-menu" />

<app-add-new-item-bottom-sheet [lotId]="lotId"
                               [(isOpen)]="isAddNewItemOpen"
                               (itemAdded)="onItemAdded($event)"
                               data-testid="cm-sheet-add-new-item" />

<ng-template #lotMenuTemplate>
  <div class="lot-menu-sheet"
       data-testid="cm-container-lot-menu">
    <app-vertical-button-group [buttons]="lotMenuButtons"
                               testId="cm-container-lot-menu-actions" />
  </div>
</ng-template>

<app-bottom-sheet [(isOpen)]="isLotPhotoMenuOpen"
                  [contentTemplate]="lotPhotoMenuTemplate"
                  [hasFooter]="false"
                  [isFullScreen]="false"
                  [preventOverlayClose]="false"
                  data-testid="cm-sheet-lot-photo-menu" />

<ng-template #lotPhotoMenuTemplate>
  <div class="lot-menu-sheet"
       data-testid="cm-container-lot-photo-menu">
    <app-vertical-button-group [buttons]="lotPhotoMenuButtons"
                               testId="cm-container-lot-photo-menu-actions" />
  </div>
</ng-template>

<input #lotPhotoCameraInput
       type="file"
       accept="image/*"
       capture="environment"
       style="display: none"
       data-testid="cm-input-lot-photo-camera"
       (change)="onLotPhotoFileSelected($event)" />

<input #lotPhotoLibraryInput
       type="file"
       accept="image/*"
       style="display: none"
       data-testid="cm-input-lot-photo-library"
       (change)="onLotPhotoFileSelected($event)" />